import { render, staticRenderFns } from "./collect-days-report.vue?vue&type=template&id=47c541a8"
import script from "./collect-days-report.vue?vue&type=script&lang=ts"
export * from "./collect-days-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports